/**
 * 结构化 API 错误 —— 全包唯一向调用方抛出的错误类型（除底层网络异常透传外）。
 *
 * 与 `@drama/contracts` 的 `ApiError` 形状（`{ error: { code, message, retryable } }`）
 * 语义对齐：transport 把后端返回的该形状解包到本类字段上，前端一套分支处理全部失败。
 */
export class ApiError extends Error {
  /**
   * @param {{ status:number, code:string, message:string, requestId?:string, retryable:boolean, details?:Record<string, unknown> }} init
   */
  constructor(init) {
    super(init.message)
    this.name = 'ApiError'
    /** @type {number} */
    this.status = init.status
    /** @type {string} */
    this.code = init.code
    /** @type {string|undefined} */
    this.requestId = init.requestId
    /** @type {boolean} */
    this.retryable = init.retryable
    /** @type {Record<string, unknown>|undefined} */
    this.details = init.details
  }
}

/** A refresh with an unknown outcome cannot safely reuse its one-time credential. */
export function authSessionNeedsLogin(error) {
  return error?.code === 'AUTH_REFRESH_OUTCOME_UNKNOWN' || (error instanceof ApiError && error.status === 401)
}
